import { useRouter } from "next/router"
import { staticLabelsSearch } from "../SearchResult/helper"

const SearchHeader = ({
  tabs = [],
  activeTab = "",
  setActiveTab = () => {},
  search = "",
  totalProductCount = 0,
  defaultLocale = "en",
}) => {
  const router = useRouter()

  const handleActiveTabChange = tabLabel => {
    const type = tabs.find(tab => tab.label === tabLabel)?.type
    if (type) {
      const currentPathname = window.location.pathname

      const searchParams = new URLSearchParams(window.location.search)
      searchParams.set("type", type)

      const targetUrl = `${currentPathname}?${searchParams.toString()}`
      router.push(targetUrl, undefined, { shallow: true })
      setActiveTab(tabLabel)
    }
  }

  const noResults = tabs.filter(tab => tab.count > 0).length === 0

  return (
    <div className="max-w-screen-lg mx-auto bg-white text-[#232323] mx-2.5">
      <div className="bg-[#f5f5f5] pt-10 px-2.5 pb-5 md:pt-[120px] md:pb-[50px] md:px-0  text-center font-sans">
        {/* Title */}
        <h1 className="text-[32px] sm:text-[50px] md:text-5xl font-light text-gray-800 mb-2 font-['Helvetica-Light',_Helvetica,_sans-serif]">
          {staticLabelsSearch[defaultLocale]?.searchResultsFor} {`"${search}"`}
        </h1>

        {/* Total Count */}
        <p className="text-[10px] text-[#232323] mb-10 font-['HelveticaRoman',_Helvetica,_sans-serif]">
          {totalProductCount} {staticLabelsSearch[defaultLocale]?.searchResults}
        </p>

        {/* Button Group */}
        {noResults ? (
          <div className="pb-[60px]" />
        ) : (
          <div className="flex flex-col md:pb-[40px] mb-[20px] md:flex-row items-center justify-center gap-4 md:gap-12">
            <div className="px-[10px] w-full md:hidden">
              <div className="relative after:content-['\e600'] after:font-['KohlerIcons'] after:text-[12px] after:w-4 after:h-4 after:absolute after:right-[15px] after:top-1/2 after:-translate-y-1/2 after:pointer-events-none">
                <select
                  className="block w-full appearance-none border-solid border border-[#dbdbdb] font-[HelveticaRoman, Helvetica, sans-serif] text-[#232323] py-3 px-4 pr-8 rounded leading-normal focus:outline-none bg-white focus:bg-white focus:border-gray-500 text-[16px] "
                  id="tab-select"
                  name="tab-select"
                  onChange={event => handleActiveTabChange(event.target.value)}
                  value={activeTab}
                >
                  {tabs
                    .filter(tab => tab.count > 0)
                    .map((tab, index) => (
                      <option key={tab?.label || index} value={tab?.label}>
                        {tab?.label} ({tab.count})
                      </option>
                    ))}
                </select>
              </div>
            </div>
            {tabs
              .filter(tab => tab.count > 0)
              .map((tab, index) => (
                <>
                  <button
                    key={index}
                    className={`hidden md:inline-block px-8 py-2 text-[14px] font-['helveticaMedium',_Helvetica,_sans-serif] font-bold tracking-[0.15em] transition-all duration-200 cursor-pointer ${
                      activeTab === tab.label
                        ? "bg-black text-white rounded-sm"
                        : "bg-transparent text-[#232323] hover:text-black"
                    }`}
                    onClick={() => handleActiveTabChange(tab.label)}
                  >
                    {tab.label}
                    <span
                      className={`ml-1 font-normal ${
                        activeTab === tab.label
                          ? "text-gray-400"
                          : "text-gray-500"
                      }`}
                    >
                      ({tab.count})
                    </span>
                  </button>
                </>
              ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default SearchHeader
